var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterviewStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16.4094L10.1563 13.8218C11.0107 12.7965 11.438 12.2838 12 12.2838C12.562 12.2838 12.9892 12.7965 13.8438 13.8218L14.1562 14.1969C15.0108 15.2222 15.438 15.735 16 15.735C16.562 15.735 16.9893 15.2222 17.8437 14.1969L20 11.6094",
    stroke: "#5B6B79",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26 14C26 19.6568 26 22.4853 24.2426 24.2426C22.4853 26 19.6568 26 14 26C8.34314 26 5.51472 26 3.75736 24.2426C2 22.4853 2 19.6568 2 14C2 8.34314 2 5.51472 3.75736 3.75736C5.51472 2 8.34314 2 14 2C19.6568 2 22.4853 2 24.2426 3.75736C25.4112 4.92585 25.8027 6.56786 25.9339 9.2",
    stroke: "#5B6B79",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1243",
    cx: 25.0714,
    cy: 25.0714,
    r: 6.07143,
    fill: "#B370AC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewStatistics);
export default __webpack_public_path__ + "static/media/interview-statistics.338cb4bcefefab96594c2f87c61da07b.svg";
export { ForwardRef as ReactComponent };